/* External dependencies */
import CognitoClient from '@mancho.devs/cognito';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

/* Loacal dependencies */
import { 
AuthActionTypes,
AuthActions,
SignUpAction,
signUpSuccess,
signUpFailed,
ConfirmCodeAction,
confirmCodeSuccess,
confirmCodeFailed,
SignInAction,
signInSuccess,
signInFailed,
ForgotPasswordAction,
forgotPasswordSuccess,
forgotPasswordFailed,
ConfirmPasswordAction,
confirmPasswordSuccess,
confirmPasswordFailed,
signOutSuccess,
signOutFailed,
getSessionSuccess,
getSessionFailed,
GetSessionAction,
 } from './actions';

const cognitoClient = new CognitoClient ({
    UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
    ClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
})

export function signUpEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action: AuthActions) => action.type === AuthActionTypes.SIGN_UP),
        switchMap(({email,password}: SignUpAction) =>
            cognitoClient.signUp(email,password).then(signUpSuccess).catch(signUpFailed),
        ),
    );
}

export function confirmCodeEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action: AuthActions) => action.type === AuthActionTypes.CONFIRM_CODE),
        switchMap(({email, code}: ConfirmCodeAction) => 
            cognitoClient.signUpConfirmCode(email,code).then(confirmCodeSuccess).catch(confirmCodeFailed)
        )
    )
}

export function signInEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action: AuthActions) => action.type === AuthActionTypes.SIGN_IN),
        switchMap(({email, password}: SignInAction) =>
            cognitoClient.signIn(email,password).then(signInSuccess).catch(signInFailed)
        )
    )
}

export function forgotPasswordEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action: AuthActions) => action.type === AuthActionTypes.FORGOT_PASSWORD),
        switchMap(({email}: ForgotPasswordAction)=>
            cognitoClient.forgotPassword(email).then(forgotPasswordSuccess).catch(forgotPasswordFailed)
        )
    )
}

export function confirmPasswordEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action: AuthActions)=> action.type === AuthActionTypes.CONFIRM_PASSWORD),
        switchMap(({email, code, password}: ConfirmPasswordAction) => 
            cognitoClient.confirmPassword(email, code, password).then(confirmPasswordSuccess).catch(confirmPasswordFailed)
        )
    )
}

export function signOutEpic (action$): Observable<AuthActions> {
    return action$.pipe(
        filter((action$: AuthActions) => action$.type === AuthActionTypes.SIGN_OUT),
        switchMap(()=>
            cognitoClient.signOut().then(signOutSuccess).catch(signOutFailed)
        )
    )
}

export function getSessionEpic(action$): Observable<AuthActions> {
  return action$.pipe(
    filter((action: AuthActions) => action.type === AuthActionTypes.GET_SESSION),
    mergeMap(({}: GetSessionAction) =>
      from(getSessionPromise()).pipe(
        map((session: CognitoUserSession) => {
          const accessToken = session.getAccessToken().getJwtToken();
          const refreshToken = session.getRefreshToken().getToken();
          const idToken = session.getIdToken().getJwtToken();
          const email = session.getIdToken().decodePayload()?.email;
        
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          localStorage.setItem('idToken', idToken);
        
          return getSessionSuccess({
            email,
            session
          });
        }),
        catchError((error) => {
          console.error(error);
          return of(getSessionFailed(error));
        }),
      ),
    ),
  );
}

function getSessionPromise(): any {
    throw new Error('Function not implemented.');
}